// Ev vizitleri tablosu ↔ Visits belgesi eşlemesi

// Blank row template matching the Excel columns
export const createBlankRow = () => ({
  _isNew: true,
  _visitId: null,
  projectId: '',
  patientId: '',
  visitNumber: '',
  windowOpenDate: '',
  targetDate: '',
  windowCloseDate: '',
  clinicianFullName: '',
  scheduledDate: '',
  scheduledTime: '',
  travelBeforeHours: '',
  travelBeforeMinutes: '',
  travelBeforeDistance: '',
  visitStartDate: '',
  visitStartTime: '',
  visitEndDate: '',
  visitEndTime: '',
  visitDurationHours: '',
  visitDurationMinutes: '',
  visitDistance: '',
  travelAfterHours: '',
  travelAfterMinutes: '',
  travelAfterDistance: '',
  issueOccurred: '',
  issueResultedInMiss: '',
  issueSource: '',
  smoCorrectionRequests: '',
  clinicalPMCorrections: '',
  correctionReason: '',
  dateInitialSourceReceived: '',
  dateLatestSourceRevision: 'N/A',
  dateSourceFinalized: '',
  wasAeSaeTaken: '',
  wasDcfCreated: '',
});

// Map a Firestore visit doc → table row
export const visitToRow = (v) => {
  const ev = v.visitEvaluation || {};
  return {
    _isNew: false,
    _visitId: v.id,
    _isMirror: Boolean(v.isMirror || v.mirrorOfVisitId),
    projectId: v.projectId || '',
    patientId: v.patientId || '',
    visitNumber: v.visitNumber || '',
    windowOpenDate: ev.windowOpenDate || '',
    targetDate: ev.targetDate || '',
    windowCloseDate: ev.windowCloseDate || '',
    clinicianFullName: v.clinicianFullName || ev.clinicianFullName || '',
    // `date` first, as everywhere else: the save writes it (calendar visits start with firstVisitDate only)
    scheduledDate: v.date || v.firstVisitDate || '',
    scheduledTime: v.startTime || '',
    travelBeforeHours: ev.travelTimeBefore ? String(Math.floor(Number(ev.travelTimeBefore) / 60)) : '',
    travelBeforeMinutes: ev.travelTimeBefore ? String(Number(ev.travelTimeBefore) % 60) : '',
    travelBeforeDistance: ev.travelDistanceBefore || '',
    visitStartDate: v.visitStartDate || v.date || '',
    visitStartTime: v.visitStartTime || v.startTime || '',
    visitEndDate: v.visitEndDate || ev.visitEndDate || '',
    visitEndTime: v.visitEndTime || v.endTime || '',
    visitDurationHours: ev.visitDurationHours || '',
    visitDurationMinutes: ev.visitDurationMinutes || '',
    visitDistance: ev.visitDistance || '',
    travelAfterHours: ev.travelTimeAfter ? String(Math.floor(Number(ev.travelTimeAfter) / 60)) : '',
    travelAfterMinutes: ev.travelTimeAfter ? String(Number(ev.travelTimeAfter) % 60) : '',
    travelAfterDistance: ev.travelDistanceAfter || '',
    issueOccurred: ev.issueOccurred || '',
    issueResultedInMiss: ev.issueResultedInMiss || '',
    issueSource: ev.issueCategory || '',
    smoCorrectionRequests: ev.smoCorrectionRequests || '',
    clinicalPMCorrections: ev.qualityManagerCheck || '',
    correctionReason: ev.correctionReason || '',
    dateInitialSourceReceived: ev.dateInitialSourceReceived || '',
    dateLatestSourceRevision: ev.dateLatestSourceRevision || 'N/A',
    dateSourceFinalized: ev.dateSourceFinalized || '',
    wasAeSaeTaken: ev.wasAeSaeTaken || '',
    wasDcfCreated: ev.dcfCreated || '',
  };
};

// Map a table row → Firestore fields (the save writes only the ones that changed)
export const rowToFields = (row) => {
  const travelBefore = (Number(row.travelBeforeHours) || 0) * 60 + (Number(row.travelBeforeMinutes) || 0);
  const travelAfter = (Number(row.travelAfterHours) || 0) * 60 + (Number(row.travelAfterMinutes) || 0);

  return {
    patientId: row.patientId,
    visitNumber: row.visitNumber,
    date: row.scheduledDate,
    // The profile calendar places the visit by firstVisitDate
    firstVisitDate: row.scheduledDate,
    startTime: row.scheduledTime,
    visitStartDate: row.visitStartDate,
    visitStartTime: row.visitStartTime,
    visitEndDate: row.visitEndDate,
    visitEndTime: row.visitEndTime,
    endTime: row.visitEndTime,
    clinicianFullName: row.clinicianFullName,
    projectId: row.projectId || '',
    visitType: 'home',
    visitEvaluation: {
      windowOpenDate: row.windowOpenDate,
      targetDate: row.targetDate,
      windowCloseDate: row.windowCloseDate,
      clinicianFullName: row.clinicianFullName,
      travelTimeBefore: travelBefore > 0 ? String(travelBefore) : '',
      travelDistanceBefore: row.travelBeforeDistance,
      visitDurationHours: row.visitDurationHours,
      visitDurationMinutes: row.visitDurationMinutes,
      visitDistance: row.visitDistance,
      travelTimeAfter: travelAfter > 0 ? String(travelAfter) : '',
      travelDistanceAfter: row.travelAfterDistance,
      issueOccurred: row.issueOccurred,
      issueResultedInMiss: row.issueResultedInMiss,
      issueCategory: row.issueSource,
      smoCorrectionRequests: row.smoCorrectionRequests,
      qualityManagerCheck: row.clinicalPMCorrections,
      correctionReason: row.correctionReason,
      dateInitialSourceReceived: row.dateInitialSourceReceived,
      dateLatestSourceRevision: row.dateLatestSourceRevision || 'N/A',
      dateSourceFinalized: row.dateSourceFinalized,
      wasAeSaeTaken: row.wasAeSaeTaken,
      dcfCreated: row.wasDcfCreated,
    },
  };
};
